export default __webpack_public_path__ + "static/media/MutaAici.f281740a.svg";